import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Box } from '@mui/material';

import { useAuthStore } from '@features/auth';

import Image from '/bg2.jpg';

export const Route = createFileRoute('/_auth')({
  beforeLoad: async ({ location }) => {
    const accessToken = useAuthStore.getState().accessToken;
    const isStaff = useAuthStore.getState().isStaff;
    console.log('Auth Route - isStaff:', isStaff);
    if (accessToken) {
      throw redirect({
        to: '/',
        search: {
          // Use the current location to power a redirect after login
          // (Do not use `router.state.resolvedLocation` as it can
          // potentially lag behind the actual current location)
          redirect: location.href,
        },
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        height: '1000px',
        backgroundColor: 'primary.light',
        backgroundImage: `url(${Image})`,
        backgroundSize: 'cover',
      }}
    >
      <Outlet />
    </Box>
  );
}
